import { render, staticRenderFns } from "./Recuperar.vue?vue&type=template&id=7fa9ae72&scoped=true&"
import script from "./Recuperar.vue?vue&type=script&lang=js&"
export * from "./Recuperar.vue?vue&type=script&lang=js&"
import style0 from "./Recuperar.vue?vue&type=style&index=0&id=7fa9ae72&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa9ae72",
  null
  
)

export default component.exports